import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const Container = styled.header`
  display: flex;
  margin-bottom: 1rem;
`
const Titles = styled.div`
  flex: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
`
const Controls = styled.div`
  flex: none;
  display: flex;
  align-items: center;
`
const Title = styled.h1`
  font-size: 2rem;
  margin: 0;
`

/** DataPageHeader provides a standard header for data-intensive pages, such as those
 * that render data tables etc. */
const DataPageHeader = ({ title, subtitle, controls }) => {
  return (
    <Container>
      <Titles>
        {title && <Title>{title}</Title>}
        {subtitle}
      </Titles>
      <Controls>{controls}</Controls>
    </Container>
  )
}

DataPageHeader.propTypes = {
  title: PropTypes.any,
  subtitle: PropTypes.any,
  controls: PropTypes.any,
}

export default DataPageHeader
